import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/ManageUsers/Profile/BannerImage/Views/banner-image-profile.html';
import {trekapi} from '@/Pages/Admin/Modules/ManagePackage/Services/Trekapi';
import {trekService} from '@/Pages/Admin/Modules/ManagePackage/Services/Trekservice';
import ValidationError from '@/Pages/Admin/Modules/Common/Controllers/ValidationError';
import UploadFile from '@/Pages/Admin/Modules/Common/Controllers/UploadAny';
import {flashService} from '@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService';
import {AccountModel} from '@/Pages/Admin/Modules/Models/ManageAccount/AccountModel';
import {UserModel} from '@/Pages/Admin/Modules/Models/ManageAccount/UserModel';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';

@WithRender
@Component({
    components: {
        UploadFile,
        'validation-error': ValidationError,
    }
})
export default class BannerImageProfile extends Vue {
    protected ui: any = {};
    protected item: any = {};
    protected vars: any = {};

    constructor() {
        super();

        this.ui = {
            status: {
                logo: false,
                banner: false,
                fileUpload: false,
                fetchData: false,
            },
            error: {
                errors: {},
                has_error: false,
                error_message: {},
            },
        };

        this.item = {
            activeUser: new UserModel({}),
            accountData: new AccountModel({}),
        };

        this.vars = {
            titles: {
                btn_title: 'Upload Image',
                modal_title: 'Upload Image',
                browse_title: 'Browse Image File',
                document_title: 'Title or description for the Upload Image',
            },
            limitdata: {
                extensions: 'jpg|jpeg|bmp|png',
                maxSizeInMB: '5',
                fileType: '',
                invalidSizeMsg: 'Exceeded maximum File Upload  size 1 MB',
                invalidFileTypeMsg: 'Only Jpeg, png files are supported',
                titleRequiredMsg: 'Title field is required.',
            },
            postdata: {
                post_url: '',
                uploadType: '',
                checkTitle: false,
            },
        };
    }

    public created() {
        this.getUserInfo();
    }

    public getUserInfo() {
        if (this.ui.status.fetchData === false) {
            trekService
                .userDataRetrieve()
                .then((res: any) => {
                    this.item.activeUser = res.data.data;
                    this.item.accountData = res.data.data.account_user.account;
                })
                .catch((error: any) => {
                    common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
                        this.ui.error.errors = res;
                        this.ui.error.has_error = true;
                    });
                })
                .finally(() => {
                    this.ui.status.fetchData = true;
                });
        }
    }

    protected onUploadBannerImage(uploadType: string) {
        this.ui.status.banner = true;
        this.vars.postdata.post_url = trekapi.updateBannerImage();
        this.vars.postdata.uploadType = uploadType;
        if (uploadType === 'image') {
            this.vars.titles.btn_title = 'Upload Image';
            this.vars.titles.browse_title = 'Browse Image';
            this.vars.titles.modal_title = 'Upload Company Banner Image';
        }
        this.ui.status.fileUpload = true;
    }

    protected documentUploaded(data: any) {
        if (this.ui.status.logo === true) {
            if (data.file_type === 'image/png' || 'image/jpeg' || 'image/jpg') {
                this.item.accountData = data.account_user.account;
                this.ui.status.logo = false;
            }
            flashService.Success('Logo Uploaded', 'Image Successfully Updated.');
        }
        if (this.ui.status.banner === true) {
            if (data.file_type === 'image/png' || 'image/jpeg' || 'image/jpg') {
                this.item.accountData = data.account_user.account;
                this.ui.status.banner = false;
            }
            flashService.Success('Banner Image Uploaded', 'Image Successfully Updated.');
        }
    }

    protected onUploadLogo(uploadType: string) {
        this.ui.status.logo = true;
        this.vars.postdata.post_url = trekapi.updateLogoImage();
        this.vars.postdata.uploadType = uploadType;
        if (uploadType === 'image') {
            this.vars.titles.btn_title = 'Upload Image';
            this.vars.titles.browse_title = 'Browse Image';
            this.vars.titles.modal_title = 'Upload Company Logo';
        }
        this.ui.status.fileUpload = true;
    }


    public async closeUploadModal() {
        this.ui.status.fileUpload = false;
    }
}
